import styles from './SingleDatePicker.module.scss';
import cn from 'classnames';
import SearchIcon from '@assets/icons/date.svg?react';
import useOutsideClick from '@hooks/useOutsideClick';
import { DayPicker } from 'react-day-picker';
import { enUS, ru, tr, zhCN } from 'date-fns/locale';
import { formatDate } from '@utils/formatValues';
import { getCurrentLanguage } from '@utils/lang';
import { useRef, useState } from 'react';

interface ISingleDatePickerProps {
  bottom?: number;
  handlerSetSelectedDate: (value: (((prevState: Date | undefined) => Date | undefined) | Date | undefined)) => void;
  isNew?: boolean | undefined;
  left?: number;
  placeholder: string;
  right?: number;
  selectedDate: Date | undefined;
  top?: number;
}

const locales = {
  cn: zhCN,
  en: enUS,
  ru: ru,
  tr: tr
};

const SingleDatePicker: React.FC<ISingleDatePickerProps> = (props: ISingleDatePickerProps) => {
  const {
    bottom,
    handlerSetSelectedDate,
    isNew,
    left,
    placeholder,
    right,
    selectedDate,
    top
  } = props;

  const [isOpenDayPicker, setIsOpenDayPicker] = useState<boolean>(false);

  const elementRef = useRef<HTMLDivElement>(null);
  const currentLanguage = getCurrentLanguage();

  useOutsideClick<HTMLDivElement>(elementRef, () => setIsOpenDayPicker(false));

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + (isNew ? 3 : 1));

  return (
      <div
          className={styles.picker}
          ref={elementRef}
      >
        <button
            className={cn(styles.pickerBtn, selectedDate && styles.pickerBtnSelected)}
            onClick={() => setIsOpenDayPicker(!isOpenDayPicker)}
        >
          <SearchIcon/>
          {selectedDate ? formatDate(selectedDate, 'eeee, dd.MM') : placeholder}
        </button>
        {isOpenDayPicker && (
            <div
                className={styles.pickerSelf}
                style={{
                  top: `${top}px`,
                  right: `${right}px`,
                  bottom: `${bottom}px`,
                  left: `${left}px`
                }}
            >
              <DayPicker
                  disabled={{ before: tomorrow }}
                  locale={locales[currentLanguage]}
                  mode="single"
                  onSelect={handlerSetSelectedDate}
                  selected={new Date(selectedDate!)}
              />
            </div>
        )}
      </div>
  );
};

export default SingleDatePicker;